"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

interface IndustryImageCard {
	keyPrefix: string;
	image: string;
}

interface IndustryCardGridProps {
	namespace: string;
	cards: readonly IndustryImageCard[];
	titleKey: string;
	descKey: string;
}

export default function IndustryCardGrid({ namespace, cards, titleKey, descKey }: IndustryCardGridProps) {
	const t = useTranslations(namespace);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t(titleKey)}
					</h2>
					<p className="mx-auto text-sm leading-relaxed text-black md:text-base">{t(descKey)}</p>
				</header>

				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
					{cards.map((card) => (
						<div key={card.keyPrefix} className="flex h-full flex-col shadow-card">
							<div className="relative aspect-[4/2.5] w-full overflow-hidden">
								<Image
									src={card.image}
									alt={t(`${card.keyPrefix}Alt`)}
									fill
									sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
									className="object-cover"
								/>
							</div>
							<div className="flex flex-1 flex-col bg-[#fcfff4] p-4">
								<h3 className="mb-2 text-base font-bold leading-snug text-black sm:mb-3 sm:text-lg">
									{t(`${card.keyPrefix}Title`)}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">{t(`${card.keyPrefix}Desc`)}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
